import { 
    PROBE_TRACE_GET_REQUEST, PROBE_TRACE_GET_SUCCESS, PROBE_TRACE_GET_ERROR, 
    PROBE_TRACE_GET_BY_KEY_REQUEST, PROBE_TRACE_GET_BY_KEY_SUCCESS, PROBE_TRACE_GET_BY_KEY_ERROR, 
    PROBE_TRACE_ADD_REQUEST, PROBE_TRACE_ADD_SUCCESS, PROBE_TRACE_ADD_ERROR, 
    PROBE_TRACE_EDIT_REQUEST, PROBE_TRACE_EDIT_SUCCESS, PROBE_TRACE_EDIT_ERROR, 
    PROBE_TRACE_DELETE_REQUEST, PROBE_TRACE_DELETE_SUCCESS, PROBE_TRACE_DELETE_ERROR
} from "../constants/probeTraceConstants";

const initialState = {
    probeTraces: [],
    probeTrace: {},
    loading: false,
    success: null,
    error: null,
    probeTraceRequestedCount: 0,
};

export const probeTraceReducer = (state = initialState, action) => {
    switch (action.type)     {
        case PROBE_TRACE_GET_REQUEST:
            return {
                ...state,
                probeTraceRequestedCount: ++state.probeTraceRequestedCount,
                loading: true,
            };
        case PROBE_TRACE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                probeTraces: action.payload,
                success: true,
            };
        case PROBE_TRACE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_TRACE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_TRACE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                probeTrace: action.payload,
                success: true,
            };
        case PROBE_TRACE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_TRACE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_TRACE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_TRACE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_TRACE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_TRACE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_TRACE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case PROBE_TRACE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PROBE_TRACE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PROBE_TRACE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
